import { useState, useEffect } from 'react';

/**
 * This hook returns a boolean representing whether or not to allow 
 * rendering, but it is delayed with a timeout to allow for a 
 * transition/animation to complete before the bool is flipped.
 * See onboarding-card.js for example.
 * 
 * @param {*} isMounted 
 * @param {*} delayTime 
 */
export default function useDelayUnmount(isMounted, delayTime) {
  const [ shouldRender, setShouldRender ] = useState(false);

  useEffect(() => {
    let timeoutId;
    if (isMounted && !shouldRender) {
      setTimeout(() => setShouldRender(true), delayTime);
    }
    else if(!isMounted && shouldRender) {
      timeoutId = setTimeout(
        () => setShouldRender(false), 
        delayTime
      );
    }
    return () => clearTimeout(timeoutId);
  }, [isMounted, delayTime, shouldRender]);
  return shouldRender;
}